import React from 'react';

import cs from 'classnames';

import { useTableContext } from 'lib/context/TableContext/TableContext';
import { pluralize } from 'lib/helpers/utility';
import { useWindowSize } from 'lib/hooks/useWindowSize';

import Icon from 'components/shared/Icon/Icon';
import Typography from 'components/shared/Typography/Typography';

const variantClassNames = {
  light: 'bg-white border shadow-spread-medium p-3 rounded-lg border-solid border-neutral-300',
  dark: 'bg-neutral-700'
};

export const RowSelectionActions = ({ actions, loading, variant = 'dark' }) => {
  const { selectedRows, setSelectedRows, gridApi, ...rest } = useTableContext();

  const totalSelected = selectedRows?.length;

  const { device } = useWindowSize();
  const isSmallDevice = device === 'tablet' || device === 'tablet-sm' || device === 'mobile';
  const isWhiteVariant = variant === 'light';

  if (!actions) return null;

  const clearSelection = () => {
    gridApi.deselectAll();
    setSelectedRows([]);
  };

  return (
    <div
      className={cs(
        'bottom-10 left-1/2 w-full min-w-fit max-w-[760px] -translate-x-1/2',
        'flex items-center justify-between gap-4 py-3 pl-4 pr-3',
        'z-40 rounded-lg border border-solid',
        'transition-all duration-300 ease-out',
        isSmallDevice ? 'fixed w-[calc(100%-120px)] -translate-x-1/2' : 'absolute',
        totalSelected > 0 ? 'opacity-1 translate-y-0' : 'translate-y-[200%] opacity-0',
        variantClassNames[variant]
      )}>
      <div className="flex items-center gap-3">
        <Icon
          icon="close-linear"
          color={!isWhiteVariant ? 'white' : 'neutral'}
          shade={700}
          size={16}
          onClick={clearSelection}
          className="cursor-pointer rounded hover:opacity-70"
        />

        <Typography
          variant="label"
          size="small"
          color={!isWhiteVariant ? 'white' : 'neutral-700'}
          weight="medium">
          {totalSelected} {pluralize('item', totalSelected)} selected
        </Typography>
      </div>

      <div
        className={cs(
          'flex origin-center items-center gap-3 opacity-100',
          'transition-transform duration-300 ease-out will-change-transform',
          {
            'scale-0 delay-300': totalSelected === 0,
            'scale-100': totalSelected > 0
          }
        )}>
        {typeof actions === 'function'
          ? actions({ selectedRows, setSelectedRows, gridApi, loading, ...rest })
          : actions}
      </div>
    </div>
  );
};
